<template>
  <div>

    <div class="row" v-if="isSelf">
      <div class="col-md-12">

        <div class="row-image">

          <img v-if="user.image" :src="user.image" class="img-fluid rounded-circle mr-3">
          <img v-else src="avatar.png" class="img-fluid rounded-circle mr-3">
          <div>
            <button @click="$refs.img.click()" class="btn btn-link">Clique aqui para escolher uma foto para exibir no seu perfil</button>
            <input ref="img" style="display: none" @change="setImage" type="file" accept=".png, .PNG., .jpg, .JPG">
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-12 mt-3">
        <label for="name">Nome</label>
        <input v-model="currentUser.name" :disabled="!canEditableName()" type="text" class="form-control" id="name">
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-3">
        <label for="email">Email</label>
        <input v-model="currentUser.email" :disabled="currentUser.id" type="text" class="form-control" id="email">
      </div>
    </div>

    <!-- #80506: "Tipo de perfil" deixou de ser campo próprio — quem define é o
         grupo. "Administrador da Conta" e "Membro" são grupos de sistema, então
         a virada não muda o acesso de ninguém. As empresas também saíram daqui:
         o recorte por CNPJ passou a ser do grupo. -->
    <div class="row">
      <div class="col-md-12 mt-3">
        <label>Acesso</label>
        <user-access-panel v-model="currentUser.groupIds"/>
      </div>
    </div>

    <div class="row" v-if="isSelf">
      <div class="col-md-12 mt-3">

      <label @click="togglePassword()" class="btn btn-link">
        Alterar Senha
        {{user.password}}
      </label>
        <div v-if="showPassword" class="ibox">
          <div class="ibox-content">
            <label for="current-passoword">Senha</label>
            <input v-model="currentUser.currentPassword" type="password" class="form-control" id="current-passoword">
            <label for="passoword">Nova senha</label>
            <input v-model="currentUser.password" type="password" class="form-control" id="passoword">
            <label for="password-confirmation">Repetir nova senha</label>
            <input v-model="currentUser.passwordConfirmation" type="password" class="form-control" id="password-confirmation">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-3 text-right">
        <button class="btn btn-outline mr-2" @click="cancel">Cancelar</button>
        <button class="btn btn-primary" @click="$emit('saveUser', currentUser)">{{ buttonSave }}</button>
      </div>
    </div>

  </div>
</template>

<script>
  import User from '@/models/User'
  import GetUser from '@/mixins/GetUser'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import UserAccessPanel from '@/components/user/UserAccessPanel'

  export default {
    components: { UserAccessPanel },
    computed: {
      isSelf() {
        return this.user.id === this.getUser.id
      }
    },
    created() {
      this.currentUser = User.clone(this.user)
      this.$set(this.currentUser, 'groupIds', (this.user.permissionGroups || []).map(group => group.id))
    },
    data() {
      return {
        currentUser: {},
        showPassword: false
      }
    },
    methods: {
      cancel() {
        this.$emit('cancelSaveUser')
      },
      canEditableName() {
        if (!this.user.id)
          return true
        else
          return this.isSelf
      },
      clear() {
        this.currentUser = User.clone(this.user)
      },
      setImage(e) {
        const formData = new FormData()
        formData.append('user[avatar]', e.target.files[0])

        this.axios.put(`users/${this.user.id}/avatar`,
          formData, { headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => this.$parse.toCamelcase(response.data))
          .then(user => this.user.image = user.image)
          .catch(e => this.open(e))
      },
      togglePassword() {
        this.showPassword = !this.showPassword

        if (!this.showPassword) {
          this.currentUser.password = ''
          this.currentUser.passwordConfirmation = ''
          this.currentUser.currentPassword = ''
        }
      }
    },
    mixins: [GetUser, GlobalLoading],
    name: 'Form',
    props: {
      buttonSave: { default: 'Salvar', type: String },
      user: { required: true, type: Object }
    }
  }
</script>

<style scoped>

  .row-image {
    display: flex;
    flex-direction: row;
  }

  .row-image input {
    color: black;
  }

  .row-image img {
    width: 250px;
  }

  label {
    color: var(--primary-text-color);
  }

  .form-control {
    color: var(--input-text-color);
    background-color: var(--input-bg);
    border-color: var(--input-border);
  }

  .form-control:disabled {
    background-color: var(--input-disabled-bg, #e9ecef);
    color: var(--input-disabled-text, #6c757d);
    opacity: 1;
  }

  .custom-select {
    color: var(--input-text-color);
    background-color: var(--input-bg);
    border-color: var(--input-border);
  }

</style>
